import React, { Component } from 'react';
import styles from './detailBonusStates.module.scss';
import Link from 'next/link';
import HiddenBonus from "./hiddenBonus";
import { sendMetrics } from "../../../utils/misc";

export default class BonusesNeedDonation extends Component {
  props: {
    id?: number
  }
  constructor(props) {
    super(props);
  }

  getText = () => {
    if (this.props.id === 249) {
      return (
        <ul className={styles.BonusesNeedDonationList}>
          <li>Минимум 2 подтверждённых донаций</li>
          <li>Минимум 1 подтверждённая донация в текущем году</li>
          <li>Минимум 1 подтверждённая донация после регистрации</li>
          <li>Ранее не была получена футболка в подарок</li>
          <li>Есть подтверждённая почта</li>
          <li>Почта не отписана от рассылки</li>
        </ul>
      );
    }
    if (this.props.id === 230) {
      return (
        <span>Чтобы взять бонус нужно иметь минимум 2 подтверждённые донацию за последние 180 дней</span>
      );
    }

    return <span>Чтобы взять бонус нужно иметь подтверждённую донацию за последние 180 дней</span>
  }

  render() {
    return (
      <div className={styles.BonusesNeedDonation}>
        <HiddenBonus />
        <div className={styles.BonusesNeedDonationShow}>
          <div className={styles.BonusesNeedDonationShowTitle}>
            <span>{this.props.id === 249 ? 'Не выполнены условия' : 'Необходима донация'}</span>
          </div>
          <div className={styles.BonusesNeedDonationShowText}>
            {this.getText()}
          </div>
          <div className={styles.BonusesNeedDonationShowLinks}>
            <Link href={'/how'}>
              <a
                onClick={() => sendMetrics('to_how_from_bonus')}>Как стать донором?</a>
            </Link>
            <Link href={'/bloodstations'}>
              <a
                onClick={() => sendMetrics('to_bloodstations_from_bonus')}>Где сдать кровь?</a>
            </Link>
            <Link href={'/profile/add_donation'}>
              <a
                onClick={() => sendMetrics('to_add_donation_from_bonus')}>Добавить донацию</a>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}
